// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import landingPageStyle from "assets/jss/material-kit-pro-react/views/landingPageStyle.jsx";
// nodejs library that concatenates classes
import classNames from "classnames";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// core components
import Header from "components/Header/Header.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import React from "react";
import "../../assets/scss/material-kit-pro-react.css";
import ApiClient from "../../services/api-client/ApiClient";
import TranslationService from "../../services/translation/TransationService";
import SectionFacilities from "./Sections/SectionFacilities";
import SectionFilters from "./Sections/SectionFilters";
// Sections for this page
import SectionProduct from "./Sections/SectionProduct.jsx";
import SectionWork from "./Sections/SectionWork.jsx";
import QxQFooter from "./Partials/QxQFooter";
import {
  catalanPublicWebUrl,
  englishPublicWebUrl,
  locale
} from "../../assets/const";
import englishBadge from "assets/img/badges/badge-english-provisional.png";
import spanishBadge from "assets/img/badges/badge-spanish-provisional.png";
import catalanBadge from "assets/img/badges/badge-catalan-provisional.png";

const dashboardRoutes = [];

class QxQPublicPage extends React.Component {
  state = {
    facilities: [],
    amount: 6,
    page: {
      current_page: 0
    },
    minScore: "1",
    maxScore: "5",
    name: "",
    address: ""
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.title = `QxQ - ${TranslationService.get("HOME.TITLE")}`;
    this.getFacilities();
  }

  seeMoreFacilities() {
    const amount = this.state.amount + 6;
    if (
      this.filterFacilities().length < amount &&
      this.state.page.total > this.state.facilities.length
    ) {
      this.getFacilities();
    }
  }

  getFacilities() {
    const page = this.state.page.current_page + 1;
    this.setState({
      page: { ...this.state.page, current_page: page }
    });

    ApiClient.facility
      .index({ page: page, name: this.state.name, address: this.state.address })
      .then(result => {
        const facilities = [
          ...this.state.facilities,
          ...result.data.content.data
        ].filter(
          (facility, index, self) =>
            self.findIndex(value => value.id === facility.id) === index
        );

        this.setState({
          facilities: facilities,
          page: result.data.content.pagination
        });

        if (
          this.filterFacilities().length < this.state.amount &&
          this.state.page.total > this.state.facilities
        ) {
          this.getFacilities();
        }
      });
  }

  filterFacilities() {
    return this.state.facilities.filter(
      f => f.score >= this.state.minScore && f.score <= this.state.maxScore
    );
  }

  getBadge() {
    switch (locale) {
      case "en_GB":
        return englishBadge;
      case "es_CA":
        return catalanBadge;
      case "es_ES":
        return spanishBadge;
      // eslint-disable-next-line no-case-declarations
      default:
        const domain = document.location.origin;
        switch (domain) {
          case catalanPublicWebUrl:
            return catalanBadge;
          case englishPublicWebUrl:
            return englishBadge;
          default:
            return spanishBadge;
        }
    }
  }

  timer = null;

  setValue(key) {
    return value => {
      if (this.state[key] !== value) {
        this.setState(
          {
            [key]: value,
            facilities: [],
            amount: 6,
            page: { current_page: 0 }
          },
          () => {
            if (this.timer) {
              clearTimeout(this.timer);
            }
            this.timer = setTimeout(this.getFacilities.bind(this), 200);
          }
        );
      }
    };
  }

  calculateChangeOnScroll() {
    const viewWidth = window.innerWidth;
    if (viewWidth <= 600) {
      return 50;
    }

    return 300;
  }

  render() {
    const { classes, ...rest } = this.props;
    return (
      <div>
        <Header
          color="transparent"
          routes={dashboardRoutes}
          brand="QxQ"
          links={<HeaderLinks dropdownHoverColor="info" />}
          fixed
          changeColorOnScroll={{
            height: this.calculateChangeOnScroll(),
            color: "info"
          }}
          {...rest}
        />
        <Parallax
          image={require("assets/img/primary-background.jpg")}
          filter="info"
        >
          <div className={classNames(classes.container, "container-margin")}>
            <GridContainer>
              <GridItem xs={12} sm={7} md={6} lg={4}>
                <div className={classes.headerContainer}>
                  <h2 className={classes.title}>
                    {TranslationService.get("HOME.TITLE")}
                  </h2>
                  <h5 className={classes.headerSubtitle}>
                    {TranslationService.get("HOME.SUBTITLE")}
                    <span className="arrow-lg-view">→</span>
                    <span className="arrow-sm-view">↓</span>
                  </h5>
                  <a
                    href="https://drive.google.com/file/d/1w5UeNbNN262ta3T6l6imBvFgkxfJnQA8/view"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {TranslationService.get("HOME.VIDEO")}
                  </a>
                </div>
              </GridItem>
              <GridItem xs={12} sm={5} md={6} lg={8}>
                <div
                  className={classNames(
                    classes.imageContainer,
                    "header-margin"
                  )}
                >
                  <img
                    className="home-image"
                    src={this.getBadge()}
                    alt="badge"
                  />
                </div>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>
            <SectionFilters setValue={val => this.setValue(val)} />
            <SectionFacilities
              facilities={this.filterFacilities()}
              seeMore={() => this.seeMoreFacilities()}
              allResults={
                this.state.facilities.length === this.state.page.total
              }
            />
            <SectionProduct />
          </div>
        </div>
        <div className={classes.container}>
          <SectionWork />
        </div>
        <QxQFooter classes={classes} />
      </div>
    );
  }
}

export default withStyles(landingPageStyle)(QxQPublicPage);



// WEBPACK FOOTER //
// ./src/views/QxQPublicPage/QxQPublicPage.jsx